<template>
  <div class="box" :style="{'height': windowHeight+'px'}">
    <div style="margin:0 auto;position:relative;height:100%">
      <div style="margin:0 auto;height:100%">
        <img src="static/img/success7.jpg" style="display:inline-block;width:100%;height:100%" />
        <button
          type="button"
          v-clipboard:copy="linkUrl"
          v-clipboard:success="onCopy"
          v-clipboard:error="onError"
          class="btn"
        >
          <img
            src="static/img/success7-button.png"
          />
        </button>
       <div
        class="btn-text"
          v-clipboard:copy="linkUrl"
          v-clipboard:success="onCopy"
          v-clipboard:error="onError">
        <div>商户端网址</div>
        <div>https://user.ippmaster.com/</div>
       </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      linkUrl: "https://user.ippmaster.com",
      time: 10800, // 总时间
      hour: '00',
      minute: '00',
      windowHeight: '',
      second: '00'
    };
  },
  created() {
    document.title = '注册成功-麦德通'
    // this.windowHeight = document.documentElement.clientHeight
    // if (localStorage.getItem("time10") && localStorage.getItem("time10") > 0) {
    //   this.time = localStorage.getItem("time10");
    //   this.codeTime();
    // } else {
    //   this.time = 10800;
    //   this.codeTime();
    // }
    this.codeTime()
  },
  methods: {
    /**
     * @description 点击 复制官网地址成功
     */
    onCopy() {
      this.$toast.success({message:"成功复制麦德通网址，赶快用PC浏览器登录使用吧！"})
    },
    /**
     * @description 点击 复制 官网地址失败
     */
    onError(e) {
      this.$toast.success({message:"无法复制文本"})
    },
    /**
     * @description 倒计时处理
     */
    codeTime() {
      let interval = setInterval(() => {
        this.hour = this.addZero(parseInt(this.time / 3600))
        this.minute = this.addZero(parseInt((this.time % 3600) / 60))
        this.second = this.addZero((this.time % 3600) % 60)
        // localStorage.setItem("time10", this.time);
        if (this.time-- <= 0) {
        this.hour = '00'
        this.minute = '00'
        this.second = '00'
        window.clearInterval(interval);
        // localStorage.removeItem('time10')
        this.time = 0
        }
      }, 1000);
    },
    /**
     * @description  倒计时小数 处理
     */
    addZero(num) {
      if(num<10){
        return `0${num}`
      }else{
        return num
      }
    }
  }
};
</script>
<style scoped>
@import "../assets/css/animate.min.css";
@import "../assets/css/index.css";
.box{
  overflow: hidden;
}
.btn{
  position:absolute;left: 50%;transform: translateX(-50%);bottom:2.4rem;width: 80%;outline: none;border: none;
}
.btn-text{
  color: #F9424D;
  position:absolute;left: 50%;transform: translateX(-50%);bottom:1.5rem;width: 80%;outline: none;border: none;
}
.clock {
  width: 220px;
  padding: 20px;
  height: 90px;
  background: url("../../static/img/successbg1.png") no-repeat center;
  background-size: contain;
  position: absolute;
  top: 35%;
  left: 51%;
  transform: translateX(-50%);
  padding-top: 2px;
  box-sizing: border-box;
}
.clock p {
  text-align: center;
  font-size: 20px;
  color: #f64840;
  font-weight: 700;
}
.clock p img {
  margin-right: 4.5px;
  margin-top: -4px;
}
.clock > div {
  overflow: hidden;
  text-align: center;
  width: 120px;
  margin: 10px auto;
  /* margin-left: 0.45rem; */
}
.clock > div i {
  font-style: normal;
  height: 12.6px;
  line-height: 12.6px;
  float: left;
  color: #f61d34;
  margin: 9px 2.8px;
}
.clock > div span:nth-child(1){
  margin-left: 3px;
}
.clock > div span {
  color: #f61d34;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #ecaaa4;
  font-size: 16px;
  text-align: center;
  line-height: 32px;
  float: left;
}
</style>



// WEBPACK FOOTER //
// src/views/success7.vue